import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a28be42c52c570014d2c80a_1784692386306_90213d14/maritzgolf/src/app/legal/page.tsx");
